import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../constants/routes'
import Logo from '../ui/Logo'

export const ChatAnimation = ({ logoVisible, logoAnimated, isChatMode }) => {
  const [showGlassBackground, setShowGlassBackground] = useState(false)

  useEffect(() => {
    if (isChatMode) {
      // Delay the glass background to appear after the logo has moved
      const timer = setTimeout(() => {
        setShowGlassBackground(true)
      }, 1000) // Match the duration of the logo transition
      return () => clearTimeout(timer)
    } else {
      setShowGlassBackground(false)
    }
  }, [isChatMode])

  return (
    <div
      data-testid="logo-container"
      className={`transition-all duration-1000 ease-in-out ${
        isChatMode
          ? 'fixed top-0 left-0 right-0 py-6 z-20'
          : `absolute ${logoAnimated ? 'top-1/3 -translate-y-1/2' : 'top-1/2 -translate-y-1/2'}`
      } ${logoVisible ? 'opacity-100' : 'opacity-0'} ${
        isChatMode && showGlassBackground ? 'glassmorphism-header' : ''
      }`}
    >
      <div className="text-center px-8 lg:px-16 xl:px-24">
        {isChatMode ? (
          <Link to={ROUTES.HOME} className="inline-block">
            <Logo size="medium" className="mx-auto" />
          </Link>
        ) : (
          <Logo size="xlarge" className="mx-auto" />
        )}
      </div>
    </div>
  )
}

ChatAnimation.propTypes = {
  logoVisible: PropTypes.bool,
  logoAnimated: PropTypes.bool,
  isChatMode: PropTypes.bool,
}

ChatAnimation.defaultProps = {
  logoVisible: false,
  logoAnimated: false,
  isChatMode: false,
}
